// extracted by mini-css-extract-plugin
export default {"container":"CreateTeam_container__l2+Hh","centered":"CreateTeam_centered__AxqVy"};